module.exports = __webpack_public_path__ + "media/images/cureus_logo_2014-a0afab8f51368be726a5083247494571.png";